import api from '../../../services/api';

export type PlatformProfitPeriod = 'today' | '7d' | '30d' | 'month' | 'last_month' | 'year' | '12m' | 'all' | 'custom';

export interface PlatformProfitKpis {
  grossSales: number;
  gmv: number;
  revenue: number;
  revenueWithCost: number;
  revenueMissingCost: number;
  cogs: number;
  grossProfit: number;
  grossMargin: number | null;
  commission: number;
  platformCommission: number;
  commissionRatePercent: number | null;
  withdrawalFeesCollected: number;
  withdrawalsCount: number;
  netProfit: number;
  netMargin: number | null;
  refunds: number;
  refundRate: number | null;
  ordersCount: number;
  unitsSold: number;
  avgOrderValue: number;
  costCoverage: number | null;
  activeSellers: number;
  itemsMissingCost: number;
}

export interface PlatformSellerRow {
  storeId: string;
  storeName: string;
  revenue: number;
  revenueWithCost: number;
  cost: number;
  grossProfit: number | null;
  grossMargin: number | null;
  coverage: number | null;
  refunds: number;
  units: number;
  orders: number;
  estimatedCommission: number | null;
}

export interface PlatformProductRow {
  productId: string;
  title: string;
  thumbnail: string | null;
  categoryName: string;
  units: number;
  revenue: number;
  cost: number;
  profit: number | null;
  margin: number | null;
  hasCost: boolean;
}

export interface PlatformProfitReport {
  period: {
    key: PlatformProfitPeriod;
    label: string;
    from: string;
    to: string;
    granularity: 'day' | 'week' | 'month';
    fromJalali: string;
    toJalali: string;
  };
  kpis: PlatformProfitKpis;
  previous: PlatformProfitKpis | null;
  change: Record<string, number | null> | null;
  series: Array<{ key: string; label: string; revenue: number; cost: number; profit: number; revenueWithCost: number; orders: number }>;
  topSellersByRevenue: PlatformSellerRow[];
  topSellersByProfit: PlatformSellerRow[];
  catalog: { activeProducts: number; productsMissingCost: number; productsCostCoverage: number | null };
  topProductsByRevenue: PlatformProductRow[];
  lossMaking: PlatformProductRow[];
  lossMakingCount: number;
  categories: Array<{ id: string | null; name: string; revenue: number; cost: number; profit: number | null; margin: number | null; coverage: number | null }>;
  generatedAt: string;
}

/** 403 = بدون مجوز admin_dashboard_profit_read → بخش پنهان می‌شود (بدون ریدایرکت) */
export const getPlatformProfit = (params: { period: PlatformProfitPeriod; from?: string; to?: string }) => {
  const q = new URLSearchParams({ period: params.period });
  if (params.from) q.set('from', params.from);
  if (params.to) q.set('to', params.to);
  return api.get<PlatformProfitReport>(`/admin/dashboard/profit?${q.toString()}`, { silentForbidden: true } as any);
};
